// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UzwS","left":"styles_left__1LJKQ","desktopActions":"styles_desktopActions__1CALw","title":"styles_title__2rZHg"};